/* =========================================================
   Tokyo Smoke Age Gate
   ========================================================= */

(function () {
  'use strict';

  const CONFIG = window.TokyoSmokeAgeGate;

  if (!CONFIG) return;

  const STORAGE_KEY = 'tokyoSmokeAgeVerified';
  const SESSION_KEY = 'tokyoSmokeAgeSessionVerified';

  const gate = document.getElementById('age-gate');
  const form = document.getElementById('age-gate-form');
  const dayInput = document.getElementById('age-gate-day');
  const monthInput = document.getElementById('age-gate-month');
  const yearInput = document.getElementById('age-gate-year');
  const rememberInput = document.getElementById('age-gate-remember');
  const errorMessage = document.getElementById('age-gate-error');

  if (!gate || !form || !dayInput || !monthInput || !yearInput) {
    return;
  }

  /*
   * ---------------------------------------------------------
   * Storage
   * ---------------------------------------------------------
   */

  function getStoredVerification() {

    /*
     * First check the session cookie.
     *
     * This is important for pages that may load an embedded
     * menu or navigate in a way that doesn't preserve the
     * normal sessionStorage check.
     */
    try {
      if (document.cookie.indexOf(SESSION_KEY + '=true') !== -1) {
        return true;
      }
    } catch (error) {
      // Continue to sessionStorage/localStorage checks.
    }

    /*
     * Check the current browser session.
     */
    try {
      if (sessionStorage.getItem(SESSION_KEY) === 'true') {
        return true;
      }
    } catch (error) {
      // Continue to localStorage check.
    }

    /*
     * Check the longer-term "Remember me" verification.
     */
    try {
      const stored = localStorage.getItem(STORAGE_KEY);

      if (!stored) return null;

      const timestamp = Number(stored);

      if (!Number.isFinite(timestamp)) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      const rememberDays = Number(CONFIG.rememberDays);

      if (rememberDays <= 0) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      const expiration =
        timestamp + rememberDays * 24 * 60 * 60 * 1000;

      if (Date.now() < expiration) {

        /*
         * Also mark this browser session as verified.
         */
        try {
          sessionStorage.setItem(SESSION_KEY, 'true');
        } catch (error) {
          // Session storage unavailable; continue.
        }

        /*
         * Also create the session cookie.
         */
        try {
          document.cookie =
            SESSION_KEY + '=true; path=/; SameSite=Lax; Secure';
        } catch (error) {
          // Cookie unavailable; continue.
        }

        return true;
      }

      localStorage.removeItem(STORAGE_KEY);
      return null;

    } catch (error) {
      return null;
    }
  }

  function storeVerification() {

    /*
     * ALWAYS remember the verification for this browser session.
     */
    try {
      sessionStorage.setItem(SESSION_KEY, 'true');
    } catch (error) {
      // Session storage unavailable; cookie will still be used.
    }

    /*
     * Also create a session cookie.
     *
     * The cookie expires when the browser session ends.
     */
    try {
      document.cookie =
        SESSION_KEY + '=true; path=/; SameSite=Lax; Secure';
    } catch (error) {
      // Cookie unavailable; continue.
    }

    /*
     * Only create the longer-term verification when
     * "Remember me" is checked.
     */
    const rememberDays = Number(CONFIG.rememberDays);

    if (!rememberInput.checked || rememberDays <= 0) {
      return;
    }

    try {
      localStorage.setItem(
        STORAGE_KEY,
        String(Date.now())
      );
    } catch (error) {
      /*
       * If localStorage is unavailable, simply don't
       * remember the verification beyond the session.
       */
    }
  }

  /*
   * ---------------------------------------------------------
   * Gate visibility
   * ---------------------------------------------------------
   */

  function lockPage() {
    document.documentElement.classList.add('age-gate-active');
    document.body.classList.add('age-gate-active');

    /*
     * Remove the initial render blocker now that we know
     * the visitor needs to see the age gate.
     */
    document.documentElement.classList.remove('age-gate-pending');

    gate.hidden = false;

    /*
     * Prevent the page behind the gate from scrolling.
     */
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    /*
     * Put focus into the first DOB field.
     */
    window.setTimeout(function () {
      dayInput.focus();
    }, 50);
  }

  function unlockPage() {
    document.documentElement.classList.remove('age-gate-active');
    document.body.classList.remove('age-gate-active');

    /*
     * Remove the initial render blocker.
     */
    document.documentElement.classList.remove('age-gate-pending');

    gate.hidden = true;

    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  /*
   * ---------------------------------------------------------
   * Date helpers
   * ---------------------------------------------------------
   */

  function isLeapYear(year) {
    return (
      year % 4 === 0 &&
      (year % 100 !== 0 || year % 400 === 0)
    );
  }

  function daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }

  function isValidDate(day, month, year) {
    if (
      !Number.isInteger(day) ||
      !Number.isInteger(month) ||
      !Number.isInteger(year)
    ) {
      return false;
    }

    if (year < 1900 || year > 9999) {
      return false;
    }

    if (month < 1 || month > 12) {
      return false;
    }

    if (day < 1 || day > daysInMonth(month, year)) {
      return false;
    }

    const date = new Date(
      year,
      month - 1,
      day
    );

    return (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
    );
  }

  /*
   * ---------------------------------------------------------
   * February 29 rule
   * ---------------------------------------------------------
   */

  function getBirthdayForYear(birthYear, currentYear) {
    const birthMonth = 2;
    const birthDay = 29;

    if (
      birthMonth === 2 &&
      birthDay === 29 &&
      !isLeapYear(currentYear)
    ) {
      return {
        month: 3,
        day: 1
      };
    }

    return {
      month: birthMonth,
      day: birthDay
    };
  }

  function calculateAge(day, month, year) {
    const today = new Date();

    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;
    const currentDay = today.getDate();

    let birthdayMonth = month;
    let birthdayDay = day;

    if (
      month === 2 &&
      day === 29 &&
      !isLeapYear(currentYear)
    ) {
      const adjustedBirthday = getBirthdayForYear(
        year,
        currentYear
      );

      birthdayMonth = adjustedBirthday.month;
      birthdayDay = adjustedBirthday.day;
    }

    let age = currentYear - year;

    if (
      currentMonth < birthdayMonth ||
      (
        currentMonth === birthdayMonth &&
        currentDay < birthdayDay
      )
    ) {
      age--;
    }

    return age;
  }

  /*
   * ---------------------------------------------------------
   * Error handling
   * ---------------------------------------------------------
   */

  function showError(message) {
    errorMessage.textContent = message;
    errorMessage.hidden = false;

    dayInput.setAttribute('aria-invalid', 'true');
    monthInput.setAttribute('aria-invalid', 'true');
    yearInput.setAttribute('aria-invalid', 'true');

    errorMessage.focus();
  }

  function clearError() {
    errorMessage.textContent = '';
    errorMessage.hidden = true;

    dayInput.removeAttribute('aria-invalid');
    monthInput.removeAttribute('aria-invalid');
    yearInput.removeAttribute('aria-invalid');
  }

  /*
   * ---------------------------------------------------------
   * Form submission
   * ---------------------------------------------------------
   */

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    clearError();

    const day = Number.parseInt(dayInput.value, 10);
    const month = Number.parseInt(monthInput.value, 10);
    const year = Number.parseInt(yearInput.value, 10);

    if (
      !Number.isInteger(day) ||
      !Number.isInteger(month) ||
      !Number.isInteger(year)
    ) {
      showError(
        'Please enter your complete date of birth.'
      );
      return;
    }

    if (!isValidDate(day, month, year)) {
      showError(
        'Please enter a valid date of birth.'
      );
      return;
    }

    const today = new Date();

    const birthDate = new Date(
      year,
      month - 1,
      day
    );

    if (birthDate > today) {
      showError(
        'Please enter a valid date of birth.'
      );
      return;
    }

    const age = calculateAge(
      day,
      month,
      year
    );

    const minimumAge = Number(
      CONFIG.minimumAge
    );

    if (!Number.isFinite(minimumAge)) {
      showError(
        'We were unable to verify your age. Please try again.'
      );
      return;
    }

    if (age < minimumAge) {
      showError(
        'Sorry, you must be ' +
        minimumAge +
        ' or older to enter this site.'
      );
      return;
    }

    /*
     * Successful verification.
     *
     * This ALWAYS creates a session verification.
     *
     * "Remember me" additionally creates the
     * longer-term localStorage verification.
     */
    storeVerification();

    unlockPage();
  });

  /*
   * ---------------------------------------------------------
   * DOB field navigation
   * ---------------------------------------------------------
   */

  [dayInput, monthInput, yearInput].forEach(function (input, index) {

    input.addEventListener('input', function () {
      clearError();

      const maxLength = input === yearInput ? 4 : 2;

      if (input.value.length >= maxLength) {

        if (input === dayInput) {
          monthInput.focus();
          monthInput.select();

        } else if (input === monthInput) {
          yearInput.focus();
          yearInput.select();
        }
      }
    });

    input.addEventListener('keydown', function (event) {

      if (
        event.key === 'Backspace' &&
        input.value === '' &&
        index > 0
      ) {
        const previousInput =
          [dayInput, monthInput, yearInput][index - 1];

        previousInput.focus();
        previousInput.select();
      }
    });

  });

  /*
   * ---------------------------------------------------------
   * Initialize
   * ---------------------------------------------------------
   */

  if (getStoredVerification()) {
    unlockPage();
  } else {
    lockPage();
  }

})();